






































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {PayrollDetailsDTO} from "@/dto/payroll/PayrollDTO";
import GeneralReportControlPanelModal
	from "@/components/payroll/reports/general/GeneralReportControlPanelModal.vue";
import PayrollReportControlPanelModal
	from "@/components/payroll/reports/PayrollReportControlPanelModal.vue";

@Component
export default class PayrollDetailsReportView extends Vue {

	@Prop()
	private report!: PayrollDetailsDTO

}

